import sscache from 'session-storage-cache';
import { isDevelopment } from '../isEnv';
import { MINUTES_TO_SECONDS } from '../../constants';

export const loginOnAmazon = (): Promise<AmazonLoginResponse> =>
  new Promise((resolve, reject) => {
    if (!window.amazon) {
      return reject('Amazon SDK is not loaded.');
    }

    window.amazon.Login.setSandboxMode(isDevelopment());

    window.amazon.Login.authorize(
      { scope: 'profile payments:widget payments:shipping_address' },
      (response: AmazonLoginResponse) => {
        if (response.access_token) {
          sscache.set(
            'amazonAccessToken',
            response.access_token,
            Number(response.expires_in) / MINUTES_TO_SECONDS
          );
          resolve(response);
        } else {
          reject('Amazon login failed.');
        }
      }
    );
  });
